import { CAccordion } from './CAccordion.js';
import { CAccordionBody } from './CAccordionBody.js';
import { CAccordionButton } from './CAccordionButton.js';
import { CAccordionHeader } from './CAccordionHeader.js';
import { CAccordionItem } from './CAccordionItem.js';

const CAccordionPlugin = {
    install: (app) => {
        app.component(CAccordion.name, CAccordion);
        app.component(CAccordionBody.name, CAccordionBody);
        app.component(CAccordionButton.name, CAccordionButton);
        app.component(CAccordionHeader.name, CAccordionHeader);
        app.component(CAccordionItem.name, CAccordionItem);
    },
};

export { CAccordion, CAccordionBody, CAccordionButton, CAccordionHeader, CAccordionItem, CAccordionPlugin };
//# sourceMappingURL=index.js.map
